import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class NgSelectSimpleService {

  constructor(
    @Inject('NG_SELECT_SIMPLE_VALIDATOR_MESSAGE') private validatorMessage: boolean = false,
    @Inject('NG_SELECT_SIMPLE_TOOLTIP_MESSAGE') private tooltipMessage: boolean = true,
    @Inject('NG_SELECT_SIMPLE_OPEN_WHEN_FOCUS') private openWhenFocus: boolean = false,
    @Inject('NG_SELECT_SIMPLE_SEARCH_BY') private searchBy: string = "value",
    @Inject('NG_SELECT_SIMPLE_MARK_FIRST_ITEM') private markFirstItem: boolean = false,
    @Inject('NG_SELECT_SIMPLE_SUBMITTED') private submitted: boolean = true,
    @Inject('NG_SELECT_SIMPLE_SEARCHABLE') private searchable: boolean = true,
    @Inject('NG_SELECT_SIMPLE_VALIDATOR_ALERT') private validatorAlert: boolean = false,
    @Inject('NG_SELECT_SIMPLE_UPPER_CASE') private upperCase: boolean = false,
    @Inject('NG_SELECT_SIMPLE_APPEND_TO') private appendTo: string = "body",
    @Inject('NG_SELECT_SIMPLE_LOADING_TEXT') private loadingText: string = "Cargando...",
    @Inject('NG_SELECT_SIMPLE_CLEAR_ALL_TEXT') private clearAllText: string = "Limpiar",
    @Inject('NG_SELECT_SIMPLE_MARK_FIRST') private markFirst: boolean = true,
    @Inject('NG_SELECT_SIMPLE_CLEARABLE') private clearable: boolean = true,
    @Inject('NG_SELECT_SIMPLE_CLEAR_ON_BACKSPACE') private clearOnBackspace: boolean = false,
    @Inject('NG_SELECT_SIMPLE_VIRTUAL_SCROLL') private virtualScroll: boolean = true,
    @Inject('NG_SELECT_SIMPLE_OPEN_ON_ENTER') private openOnEnter: boolean = false,
  ) {
  }

  public getValidatorMessage(): boolean {
    return this.validatorMessage;
  }
  public getTooltipMessage(): boolean {
    return this.tooltipMessage;
  }
  public getOpenWhenFocus(): boolean {
    return this.openWhenFocus;
  }
  public getSearchBy(): string {
    return this.searchBy;
  }
  public getMarkFirstItem(): boolean {
    return this.markFirstItem;
  }
  public getSubmitted(): boolean {
    return this.submitted;
  }
  public getSearchable(): boolean {
    return this.searchable;
  }
  public getValidatorAlert(): boolean {
    return this.validatorAlert;
  }
  public getUpperCase(): boolean {
    return this.upperCase;
  }
  public getAppendTo(): string {
    return this.appendTo;
  }
  public getLoadingText(): string {
    return this.loadingText;
  }
  public getClearAllText(): string {
    return this.clearAllText;
  }
  public getMarkFirst(): boolean {
    return this.markFirst;
  }
  public getClearable(): boolean {
    return this.clearable;
  }
  public getClearOnBackspace(): boolean {
    return this.clearOnBackspace;
  }
  public getVirtualScroll(): boolean {
    return this.virtualScroll;
  }
  public getOpenOnEnter(): boolean {
    return this.openOnEnter;
  }
}


//   @Input() validatorMessage: boolean = false;
//   @Input() tooltipMessage: boolean = true;
//   @Input() openWhenFocus: boolean = false;
//   @Input() searchBy: string = "value";
//   @Input() markFirstItem: boolean = false;
//   @Input() submitted: boolean = true;
//   @Input() searchable: boolean = true;
//   @Input() validatorAlert: boolean = false;
//   @Input() upperCase = false;
//   @Input() appendTo: any = "body"
//   @Input() loadingText: string = "Cargando...";
//   @Input() clearAllText: string = "Limpiar";
//   @Input() markFirst: boolean = true;
//   @Input() clearable: boolean = true;
//   @Input() clearOnBackspace: boolean = false;
//   @Input() virtualScroll: boolean = true;
//   @Input() openOnEnter: boolean = false;
